export const BAD_WEATHER = ["Rain", "Gusty", "High Waves", "Squall"];

export function sCurve({ teams, jobs, assignments }, logs) {
  const weight = Object.fromEntries(jobs.map((j) => [j.id, j.weight]));
  const dates = [...new Set(logs.map((l) => l.date))].sort();
  const sorted = [...logs].sort((a, b) => a.date.localeCompare(b.date) || a.created_at.localeCompare(b.created_at));
  const targetOf = (tid) => assignments.filter((a) => a.team_id === tid && weight[a.job_id]).reduce((s, a) => s + weight[a.job_id], 0);
  const targets = Object.fromEntries(teams.map((t) => [t.id, targetOf(t.id)]));
  const totalTarget = Object.values(targets).reduce((s, v) => s + v, 0);
  const latest = {};
  let i = 0;
  return dates.map((date) => {
    while (i < sorted.length && sorted[i].date <= date) {
      const l = sorted[i++];
      latest[`${l.team_id}|${l.job_id}`] = l.status === "done" ? 100 : l.progress;
    }
    const earned = Object.fromEntries(teams.map((t) => [t.id, 0]));
    Object.entries(latest).forEach(([k, p]) => {
      const [tid, jid] = k.split("|");
      if (tid in earned && weight[jid]) earned[tid] += (weight[jid] * p) / 100;
    });
    const row = { date };
    teams.forEach((t) => { row[t.id] = targets[t.id] ? +((earned[t.id] / targets[t.id]) * 100).toFixed(1) : 0; });
    const sum = Object.values(earned).reduce((s, v) => s + v, 0);
    row.overall = totalTarget ? +((sum / totalTarget) * 100).toFixed(1) : 0;
    return row;
  });
}

export function weatherRecap(jobs, logs, keywords = ["helideck", "boatlanding"]) {
  return jobs
    .filter((j) => keywords.some((k) => j.name.toLowerCase().includes(k)))
    .map((j) => {
      const jl = logs.filter((l) => l.job_id === j.id);
      const days = new Set(jl.map((l) => l.date));
      const badDays = new Set(jl.filter((l) => BAD_WEATHER.includes(l.weather)).map((l) => l.date));
      const breakdown = Object.fromEntries(BAD_WEATHER.map((w) => [w, new Set(jl.filter((l) => l.weather === w).map((l) => l.date)).size]));
      return { job: j, daysLogged: days.size, daysLost: badDays.size, pct: days.size ? (badDays.size / days.size) * 100 : 0, breakdown };
    });
}
